import { FormArray, FormBuilder } from '@angular/forms';

import { DefaultNote } from '../coaching-base/config/default-note.model';
import { NoteCategory } from '../coaching-base/general';

import { DefaultNoteInputs } from './default-note-input.model';
import { createNoteDetail } from './note-detail.form';

export function injectDefaultNotes(
    formBuilder: FormBuilder,
    form: FormArray,
    defaultNotes: DefaultNote[],
    defaultCategory: NoteCategory,
): DefaultNoteInputs {
    if (form.controls.length > 0 || defaultNotes == null) {
        return;
    }
    const inputs: DefaultNoteInputs = {};
    [...defaultNotes]
        .sort(
            (a, b) =>
                (a.displayOrder ?? Number.MAX_VALUE) -
                (b.displayOrder ?? Number.MAX_VALUE),
        )
        .forEach((e) => {
            const item = createNoteDetail(e.categoryId ?? defaultCategory);
            form.push(formBuilder.control(item));
            inputs[item.trackingId] = {
                placeholder: e.placeholder,
                required: e.required,
                deletable: e.deletable,
            };
        });
    return inputs;
}
